<template>
  <v-app>
    <v-main>
      <v-row class="mainrow">
        <div class="sidebar">
          <Sidebar v-if="$route.name != 'login' "/>
        </div>
        <div class="main">
          <router-view/>
          <Snackbar ref="snackbar"/>
        </div>
        <!-- <Sub/> -->
      </v-row>
    </v-main>
  </v-app>
</template>

<style >
  .mainrow{
    width: 100%;
  }
  .main{
    margin-left: 275px;
    width: 100%;
  }

</style>

<script>
import Sidebar from './components/Sidebar.vue';
import Snackbar from './components/Snackbar.vue';
//import { mapActions } from 'vuex';
export default {
  name: 'App',

  components: {
    Sidebar,
    Snackbar,
  },

  data: () => ({
    //
  }),
  methods: {
        //...mapActions(['fetchclients','fetchprojects','fetchcontacts','fetchsalespersons','fetchusers','fetchuser','fetchtasks']),
  },
  mounted() {
    // if(localStorage.getItem('token'))
    // {
    //     this.fetchclients();
    //     this.fetchprojects();
    //     this.fetchcontacts();
    //     this.fetchsalespersons();
    //     this.fetchusers();
    //     this.fetchuser();
    //     this.fetchtasks();
    // }
  }
};

</script>
